import "./Header.scss";
import { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LangContext } from "../../context/langContext";
import LangSelect from "../LangSelect/LangSelect";
import logo from "../../assets/logo.png";
import Nav from "../Nav/Nav";

const Header = ({ textData, changeLang }) => {
  const [isNavActive, setIsNavActive] = useState(false);
  const lang = useContext(LangContext);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleNav = () => {
    if (!isNavActive) {
      setIsNavActive(true);
      document.body.style.touchAction = "none";
      document.body.style.overflowY = "hidden";
    } else {
      setIsNavActive(false);
      document.body.style.overflowY = "scroll";
      document.body.style.touchAction = "";
    }
  };

  return (
    <>
      <header className="header">
        <Link to="/" className="logo-wrapper">
          <img src={logo} className="logo" alt={textData[lang].logo} />
        </Link>

        <Nav textData={textData} />
        <div className="header__right-container">
          <a href="#download" className="header__download">
            <button
              type="button"
              className="default-button header__download-button"
              onClick={() => {
                return location.pathname === "/" ? null : navigate("/");
              }}
            >
              {textData[lang].header.download}
              <span className="icon-donwload" />
            </button>
          </a>

          <LangSelect changeLang={changeLang} isDropdown />
        </div>
        <button
          type="button"
          onClick={toggleNav}
          className={`header__menu-button ${
            isNavActive && "header__menu-button_close"
          }`}
        >
          {" "}
        </button>
        <div className="header__gradient" />
      </header>
      <Nav
        isMobile
        isNavActive={isNavActive}
        textData={textData}
        changeLang={changeLang}
        toggleNav={toggleNav}
      />
    </>
  );
};

export default Header;
